import React from "react";
const Divider = React.memo(function Divider() {
  return <hr className="custom-border" />;
});

export default Divider;
